module.exports = __webpack_public_path__ + "img/search-no-data.8a35fc97.svg";